import type { WorkbookSample, WorkbookSampleMethod } from '@erp/shared-types';

/** A Sample of `method`, keeping the column and seed of `current` where it has them. */
export function sampleOf(
  method: WorkbookSampleMethod,
  current: WorkbookSample,
  columns: { any: readonly string[]; dates: readonly string[] },
): WorkbookSample {
  const seed = 'seed' in current ? current.seed : 1;
  const column = 'column' in current ? current.column : undefined;
  switch (method) {
    case 'first':
    case 'last':
      return { method };
    case 'random':
      return { method, seed };
    case 'stratified':
      return {
        method,
        seed,
        column:
          column && columns.any.includes(column)
            ? column
            : (columns.any[0] ?? ''),
      };
    case 'recent':
      return {
        method,
        column:
          column && columns.dates.includes(column)
            ? column
            : (columns.dates[0] ?? ''),
      };
  }
}

/** The same Sample, with another seed: a new random draw. */
export function reshuffled(sample: WorkbookSample): WorkbookSample {
  return 'seed' in sample
    ? { ...sample, seed: (sample.seed % 2_147_483_646) + 1 }
    : sample;
}
